/* eslint-disable */
export const DEFAULT_DESTINATIONS = [
	{
		name: "Downtown Bakersfield",
		coordinates: {
			lat: 35.3733,
			lng: -119.0187,
		},
	},
	{
		name: "East Bakersfield",
		coordinates: {
			lat: 35.3772,
			lng: -118.9772,
		},
	},
	{
		name: "North Bakersfield",
		coordinates: {
			lat: 35.4244,
			lng: -119.0219,
		},
	},
	{
		name: "South Bakersfield",
		coordinates: {
			lat: 35.3486,
			lng: -119.0322,
		},
	},
];
